module.exports = __webpack_public_path__ + "img/ring_y_l_0_null.e5099808.png";